import React from 'react';

import { useTranslation, Trans } from "react-i18next";

import logo from '../img/logo.svg'

function Footer() {

  const { t } = useTranslation();

  const { hostname } = document.location;

  return (
    <div className='z-10 relative bg-[#E6E3E6]'>
      <div className='flex flex-col xl:flex-row container mx-auto pt-[160px]'>
        <img src={logo} alt="" className='w-[100px] h-[35px] mx-[20px]'/>
        <div className='ml-[20px] xl:ml-[70px] gap-[15px] flex flex-col mt-[30px] xl:mt-0'>
          <p className='text-[#1F1F1FB2] ibm-plex text-[14px] xl:text-[16px] font-normal'>{t('footer1')} +442033189335</p>
          <div>
            <p className='text-[#1F1F1FB2] ibm-plex text-[14px] xl:text-[16px] font-normal'>{t('footer2')} bei Thomas Rahbek Köhler,<br/>Wolfwilerstrasse 1, Fulenbach, Switzerland</p>
          </div>
          <p className='text-[#1F1F1FB2] ibm-plex text-[14px] xl:text-[16px] font-normal'>{t('footer3')} support@{hostname}</p>
          <p className='text-[#1F1F1FB2] ibm-plex text-[14px] xl:text-[16px] font-normal'>{t('footer9')} <a className='text-[#FE7320]' href="https://efmrc.org/#cert=exideagroup">EFMRC</a>.</p>
        </div>
        <div className='ml-[20px] xl:ml-[450px] gap-[15px] flex flex-col mt-[15px] xl:mt-0'>
          <a href="/docs/client.pdf"><p className='text-[#1F1F1FB2] ibm-plex text-[14px] xl:text-[16px] font-normal'>{t('footer4')}</p></a>
          <a href="/docs/conflict.pdf"><p className='text-[#1F1F1FB2] ibm-plex text-[14px] xl:text-[16px] font-normal'>{t('footer5')}</p></a>
          <a href="/docs/privacy.pdf"><p className='text-[#1F1F1FB2] ibm-plex text-[14px] xl:text-[16px] font-normal'>{t('footer6')}</p></a>
        </div>
      </div>
      <div className='flex flex-col container mx-auto pl-[20px] xl:pl-[205px] pt-[40px]'>
        <p className='text-[#1F1F1FB2] ibm-plex text-[12px] font-normal'>{t('footer7')}</p>
        <p className='text-[#1F1F1FB2] ibm-plex text-[12px] font-light mt-[6px] pr-[30px] xl:pr-0'><Trans>{t('footer8')}</Trans></p>
        <p className='flex justify-end pb-[150px] mt-[14px] ibm-plex text-[16px] text-[#1F1F1FB2] pr-[30px] xl:pr-0'>EXIDEA GROUP © 2025. All rights reserved.</p>      
      </div>
    </div>
  );
}

export default Footer;